import { connect } from 'react-redux';

import {
  selectLandedOnPageOne,
  selectRedirectedFromSearch,
} from 'src/components/organisms/ProductPages/modules/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { LinkCarouselTrackingLinkSource } from '../../LinkCarousel';
import type { HeaderCopyBlockProps } from '../components/HeaderCopyBlock';
import { HeaderCopyBlock } from '../components/HeaderCopyBlock';

const mapStateToProps = (
  state: ReduxApplicationState,
  { internalLinks }: { internalLinks?: { text: string; href: string }[] },
): HeaderCopyBlockProps => {
  const hasInternalLinks = internalLinks ? internalLinks.length > 0 : false;
  return {
    categoryDescription: state.products.category!.description,
    categoryHeading: state.products.category!.heading,
    categorySubheading: state.products.category!.subheading,
    categoryLinks: hasInternalLinks
      ? internalLinks!
      : state.products.navigation[0]?.options.map((categoryLink) => {
          return {
            href: categoryLink.rel!,
            text: categoryLink.title!,
          };
        }) || [],
    landedOnPageOne: selectLandedOnPageOne(state),
    openOnMount: !selectRedirectedFromSearch(state),
    trackingLinkDataSource: hasInternalLinks
      ? LinkCarouselTrackingLinkSource.SimilarAI
      : LinkCarouselTrackingLinkSource.Browse,
  };
};

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
